export enum InputFieldType {
  TEXT = "text",
  EMAIL = "email",
  TEL = "tel",
  TEXTAREA = "textarea",
  DATE = "date",
  SELECT = "select",
  CHECKBOX = "checkbox",
  NUMBER = "number",
  ARRAY_OF_OBJECT = "array_of_object",
  BULLET_LIST = "bullet_list",
  NORMAL_TEXT = "normal_text",
}

export const InputFieldTypeText: Record<InputFieldType, string> = {
  [InputFieldType.TEXT]: "Text",
  [InputFieldType.EMAIL]: "Email",
  [InputFieldType.TEL]: "Telephone",
  [InputFieldType.TEXTAREA]: "Text Area",
  [InputFieldType.DATE]: "Date",
  [InputFieldType.SELECT]: "Select",
  [InputFieldType.CHECKBOX]: "Checkbox",
  [InputFieldType.NUMBER]: "Number",
  [InputFieldType.ARRAY_OF_OBJECT]: "Array of Object",
  [InputFieldType.BULLET_LIST]: "Bullet List",
  [InputFieldType.NORMAL_TEXT]: "Normal Text",
};
